"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const colors_1 = __importDefault(require("../colors"));
const menu = {
    MuiMenu: {
        styleOverrides: {
            list: {
                paddingTop: 0,
                paddingBottom: 0,
                background: colors_1.default.secondary[600],
                overflow: "auto",
            },
        },
    },
    MuiMenuItem: {
        styleOverrides: {
            root: {
                fontSize: "0.9rem !important",
                padding: "0.6rem 1.4rem",
                background: `${colors_1.default.secondary[600]}`,
                "&.Mui-selected": {
                    background: `${colors_1.default.secondarySelected[600]} !important`,
                    "&:hover": {
                        background: colors_1.default.secondaryHover[600],
                    },
                },
                "&:hover": {
                    background: colors_1.default.secondaryHover[600],
                    color: colors_1.default.text[100],
                },
            },
        },
    },
};
exports.default = menu;
